<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" width="720px" append-to-body>
    <el-form ref="formRef" :model="form" :rules="currentRules" label-width="90px">
      <el-form-item v-if="mode === 'create'" label="appid" prop="appid">
        <DynamicOption v-model="form.appid" :placeholder="'appid/全部渠道'" :singleSelect="true" :params="searchOptions" />
      </el-form-item>
      <el-form-item v-if="mode === 'create'" label="UID" prop="uid">
        <el-input v-model="form.uid" placeholder="请输入UID" />
      </el-form-item>
      <el-form-item label="文件" prop="file">
        <el-upload action="" :http-request="doUpload" list-type="text" :show-file-list="true" :file-list="fileList"
          :limit="3" accept=".png,.jpg">
          <el-button type="primary">点击上传文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="故障描述" prop="description">
        <el-input type="textarea" :rows="3" v-model="form.description" placeholder="请输入故障描述" />
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input type="textarea" :rows="2" v-model="form.note" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DynamicOption from "@/components/DynamicOption/index.vue";
import { saveCaptureLog, updateCaptureLog, uploadFile } from '@/api/clientManageMent/logList'

export default {
  name: 'logEditDialog',
  components: { DynamicOption },
  data() {
    return {
      visible: false,
      mode: 'create',
      form: {
        id: undefined,
        appid: '',
        uid: '',
        description: '',
        note: '',
        file: null
      },
      rules: {
        appid: [{ required: true, message: '请选择appid', trigger: 'change' }],
        uid: [{ required: true, message: '请输入UID', trigger: 'blur' }]
      },
      fileList: [],
      searchOptions: {
        url: '/admin/channelConfig/getDynamicOption',
        method: 'get'
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.mode === 'create' ? '新增' : '修改'
    },
    currentRules() {
      // 在编辑模式下移除appid和uid的校验规则
      if (this.mode === 'edit') {
        const editRules = { ...this.rules }
        delete editRules.appid
        delete editRules.uid
        return editRules
      }
      return this.rules
    }
  },
  methods: {
    open(payload = {}) {
      this.mode = payload.mode || 'create'
      if (payload.data) {
        this.form = {
          id: payload.data.id,
          appid: payload.data.appid,
          uid: payload.data.uid,
          description: payload.data.description,
          note: payload.data.note || payload.data.remark || ''
        }
      } else {
        this.form = { id: undefined, appid: '', uid: '', description: '', note: '', file: null }
      }
      this.fileList = []
      this.visible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },

    async doUpload(options) {
      const file = options.file

      // 检查文件大小限制（5MB = 5 * 1024 * 1024 bytes）
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过5MB')
        options.onError && options.onError(new Error('文件大小超限'))
        return
      }

      try {
        // 调用uploadFile API上传文件
        const formData = new FormData()
        formData.append('file', file)

        const response = await uploadFile(formData)
        console.log(response)
        // 上传成功后，将文件信息添加到列表中
        this.fileList.push({
          name: file.name,
          url: (response.data && response.data.data.imgpath) || '',
          uid: (response.data && response.data.data.uid) || Date.now()
        })

        // 文件上传成功后无需触发 file 字段校验

        options.onSuccess && options.onSuccess(response)
        this.$message.success('文件上传成功')
      } catch (error) {
        console.error('文件上传失败：', error)
        this.$message.error('文件上传失败')
        options.onError && options.onError(error)
      }
    },

    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return

        try {
          // 构建参数，按照pic1、pic2、pic3的方式设置图片路径
          const params = {
            id: this.form.id,
            uid: this.form.uid,
            description: this.form.description,
            note: this.form.note,
            appid: this.form.appid
          }

          // 根据fileList中的文件数量，设置pic1、pic2、pic3
          this.fileList.forEach((file, index) => {
            if (index < 3) {
              params[`pic${index + 1}`] = file.url
            }
          })

          if (this.mode === 'create') {
            await saveCaptureLog(params)
          } else {
            await updateCaptureLog(params)
          }

          this.$message.success('保存成功')
          this.visible = false
          this.$emit('saved')
        } catch (error) {
          console.error('保存失败：', error)
          this.$message.error('保存失败')
        }
      })
    }
  }
}
</script>

<style scoped></style>
